const semanticClassNames = {
  root: 'header',
} as const;

export default semanticClassNames;
